export const alertOptions = {
  offset: 14,
  position: 'top right',
  theme: 'dark',
  time: 5000,
  transition: 'scale'
}



// WEBPACK FOOTER //
// ./src/constants.js